import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { HistoryModuleView } from "./module-view";

export default function HistoriesModal(props) {
  const { t } = useTranslation();
  const { open, onClose, module: moduleName, module_param, entityMeta } = props;

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-[1px] transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-3xl border border-slate-200 bg-white text-left align-middle shadow-xl transition-all sm:max-w-2xl">
                <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-5 py-4 sm:px-6">
                  <Dialog.Title className="text-base font-semibold text-slate-900">
                    {t("histories.title")}
                  </Dialog.Title>
                  <button
                    type="button"
                    onClick={onClose}
                    className="rounded-xl border border-transparent p-1.5 text-slate-500 transition hover:border-slate-200 hover:bg-slate-50 hover:text-slate-800"
                  >
                    <span className="sr-only">{t("histories.close")}</span>
                    <XMarkIcon className="h-5 w-5" aria-hidden />
                  </button>
                </div>
                <div className="max-h-[min(70vh,640px)] overflow-y-auto px-5 py-4 sm:px-6 sm:py-5">
                  <HistoryModuleView
                    variant="modal"
                    open={open}
                    module={moduleName}
                    module_param={module_param}
                    entityMeta={entityMeta}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
